import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      className="toaster group"
      toastOptions={{
        style: {
          background: '#1a1a1a',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          color: '#fff',
        },
        classNames: {
          toast: "group toast",
          description: "text-gray-400",
          actionButton: "bg-purple-500 text-white",
          cancelButton: "bg-gray-700 text-gray-300",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
